module.exports = __webpack_public_path__ + "static/hero-12cb51c5c9cbe1deabf014a193ff62a2.svg";